import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { SHOOTINGSTATUS } from '../../interfaces/shooting-schedule-status';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-daily-plan-picker',
    templateUrl: './daily-plan-picker.component.html',
    styleUrls: ['./daily-plan-picker.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DailyPlanPickerComponent implements OnInit {

  @Input() minDate: any = null;
  @Input() maxDate: any = null;
  @Input() list: any[] = [];
  @Input() required: boolean = false;

  @Output() onActionCalendar = new EventEmitter<any>();

  readonly SHOOTINGSTATUS = SHOOTINGSTATUS;

  formData = {
    date: null
  }
  shooting: any = null;

  constructor(
    public _gS: GlobalService
  ) { }

  ngOnInit(): void {
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const formattedDate = this._gS.parseDateToString(cellDate);
      const shoFind =  this.list.find(sho => String(sho.date) == String(formattedDate));
      if (shoFind) {
        switch(shoFind.shooting_shedule_status_id) {
          case (SHOOTINGSTATUS.Abierto): 
            return 'sho-open';
          break;
          case (SHOOTINGSTATUS.Cancelado): 
            return 'sho-canceled';
          break;
          case (SHOOTINGSTATUS.Cerrado): 
            return 'sho-closed';
          break;
          case (SHOOTINGSTATUS.Grabando): 
            return 'sho-recording';
          break;
          case (SHOOTINGSTATUS.Privado): 
            return 'sho-private';
          break;
          case (SHOOTINGSTATUS.Tentativo): 
            return 'sho-tentative';
          break;
        }
      }
    }
    return '';
  };

  filterDays = (d: Date | null): boolean => {
    const formattedDate = this._gS.parseDateToString(d || new Date());
    const shoFind =  this.list.find(sho => String(sho.date) == String(formattedDate) && (sho.shooting_shedule_status_id == SHOOTINGSTATUS.Abierto || sho.shooting_shedule_status_id == SHOOTINGSTATUS.Privado || sho.shooting_shedule_status_id == SHOOTINGSTATUS.Grabando));
    if (shoFind) return true;
    else return false;
    return true;
  };

  onActionDate() {
    this.shooting = { ...this.formData };
    this.shooting = this._gS.parseDateToString(this.shooting.date);
    this.shooting =  this.list.find(sho => String(sho.date) == String(this.shooting));
    this.onActionCalendar.emit(this.shooting);
  }

  onDatepickerInputFocus(event: any) {
    event.target.blur();
  }

  onDatepickerOpened(event: any) {
    if (event) event.preventDefault();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.list) this.formData.date = null;
  }
}
